export default __webpack_public_path__ + "static/media/Group1628.38419ac3.png";